var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 1.06738C11.8571 0.751329 12.2258 0.60697 12.542 0.745117C15.7044 2.12699 17.916 5.28366 17.916 8.95801C17.916 13.9055 13.9055 17.916 8.95801 17.916C4.01049 17.916 5.02283e-05 13.9055 0 8.95801C0 5.28366 2.21158 2.12699 5.37402 0.745117C5.69021 0.60697 6.05894 0.751329 6.19727 1.06738C6.33545 1.38365 6.19123 1.75239 5.875 1.89062C3.15126 3.08068 1.25 5.79807 1.25 8.95801C1.25005 13.2152 4.70084 16.666 8.95801 16.666C13.2152 16.666 16.666 13.2152 16.666 8.95801C16.666 5.79807 14.7648 3.08068 12.041 1.89062C11.7248 1.75239 11.5806 1.38365 11.7188 1.06738ZM8.95801 0C9.30319 8.05736e-09 9.58301 0.279822 9.58301 0.625V3.95801C9.58301 4.30319 9.30319 4.58301 8.95801 4.58301C8.61283 4.58301 8.33301 4.30319 8.33301 3.95801V0.625C8.33301 0.279822 8.61283 0 8.95801 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.deb7be898462d091b3f42749eccd0e7d.svg";
export { ForwardRef as ReactComponent };